<template>
  <SelectComponent
    v-model="comp"
    :label="label"
    v-bind="$attrs"
    v-on="$listeners"
    items="/api/resource/contact"
    search
    multiple
    :empty-label="$t('select') + '...'"
  />
</template>

<script>
import { ValueComp } from '@/utils'
import SelectComponent from '@kvass/custom-fields/src/Fields/SelectModal'
import { i18n } from '@/i18n'

const meta = {
  order: 1,
  label: i18n.tc('owner', 2),
}

export { meta }
export default {
  props: {
    value: Array,
    label: { type: String, default: meta.label },
  },
  computed: {
    comp: ValueComp(),
  },
  components: {
    SelectComponent,
  },
}
</script>
